import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { put, takeLatest } from "redux-saga/effects";


// Import the transformer creator
const expireReducer = require('redux-persist-expire');

export const actionTypes = {
  Login: "[Login] Action",
  TokenRefreshed: "[TokenRefreshed] Action",
  Logout: "[Logout] Action",
  Register: "[Register] Action",
  UserRequested: "[Request User] Action",
  UserLoaded: "[Load User] Auth API",
  UserUpdated: "[Load User] Auth API",
  MenuLoaded: "[Load Menu] Auth API"
};

const initialAuthState = {
  user: undefined,
  userDetail: undefined,
  authToken: undefined,
  refreshToken: undefined,
  // tryRefreshTokenCount: 0,
};

export const reducer = persistReducer(
  {
    storage, key: "v706-Kherad-auth",
    whitelist: ["user", "userDetail", "authToken", "refreshToken", "menu", "tryRefreshTokenCount"]
    , transforms: [
      // Create a transformer by passing the reducer key and configuration. Values
      // shown below are the available configurations with default values
      expireReducer('preference', {
        // (Optional) Key to be used for the time relative to which store is to be expired
        persistedAtKey: 'auth',
        // (Required) Seconds after which store will be expired
        expireSeconds: 28800,
        // (Optional) State to be used for resetting e.g. provide initial reducer state
        expiredState: {},
        // (Optional) Use it if you don't want to manually set the time in the reducer i.e. at `persistedAtKey` 
        // and want the store to  be automatically expired if the record is not updated in the `expireSeconds` time
        autoExpire: true
      })
      // You can add more `expireReducer` calls here for different reducers
      // that you may want to expire
    ]
  },
  (state = initialAuthState, action) => {
    switch (action.type) {
      case actionTypes.Login: {
        const { authToken, refreshToken } = action.payload;
        return { authToken, refreshToken, user: undefined, userDetail: undefined };
      }
      case actionTypes.TokenRefreshed: {
        // const { user, menu } = state;
        return { ...action.payload };
      }
      case actionTypes.Register: {
        const { authToken } = action.payload;

        return { authToken, user: undefined };
      }
      case actionTypes.Logout: {
        // TODO: Change this code. Actions in reducer aren't allowed.
        return initialAuthState;
      }
      case actionTypes.UserLoaded: {
        const { user, menu } = action.payload;
        return { ...state, user, menu };
      }
      case actionTypes.UserUpdated: {
        const { user } = action.payload;
        return { ...state, user };
      }
      case actionTypes.MenuLoaded: {
        const { menu } = action.payload;
        return { ...state, menu };
      }
      default:
        return state;
    }
  }
);

export const actions = {
  login: (authToken, refreshToken) => ({ type: actionTypes.Login, payload: { authToken, refreshToken } }),
  tokenRefreshed: (authToken, refreshToken, user, menu) => ({ type: actionTypes.TokenRefreshed, payload: { authToken, refreshToken, user, menu } }),
  register: authToken => ({
    type: actionTypes.Register,
    payload: { authToken }
  }),
  logout: () => ({ type: actionTypes.Logout }),
  requestUser: user => ({ type: actionTypes.UserRequested, payload: { user } }),
  fulfillUser: (user, menu) => ({ type: actionTypes.UserLoaded, payload: { user, menu } }),
  updateUser: (user) => ({ type: actionTypes.UserUpdated, payload: { user } }),
  // fulfillMenu: menu => ({ type: actionTypes.MenuLoaded, payload: { menu } })
};

export function* saga() {
  yield takeLatest(actionTypes.Login, function* loginSaga() {
    yield put(actions.requestUser());
  });

  yield takeLatest(actionTypes.Register, function* registerSaga() {
    yield put(actions.requestUser());
  });

  // yield takeLatest(actionTypes.TokenRefreshed, function* tokenRefreshed() {
  //   yield put(actions.tokenRefreshed());
  // });


  yield takeLatest(actionTypes.UserRequested, function* userRequested() {
    // const { data: user } = yield getUserByToken();

    const user = JSON.parse(sessionStorage.authUser);
    const menu = JSON.parse(sessionStorage.authUserMenu);
    const userDetail = JSON.parse(sessionStorage.userDetail);

    yield put(actions.fulfillUser(user, menu, userDetail));
    //  yield put(actions.fulfillMenu(menu));
  });


}
